<template>
<div class='b-user-list'>
    <div class='b-user-list__inner'>
        <div v-for='user in localList'
             class='b-user-list__item'
             :class='{ "b-user-list__item--active": userFilterId === user.id }'
             @click='$emit("click", user.id)'>
            <div :style='{ "backgroundColor": user.color }'
                 class='b-user-list__item__avatar'>
                <FwIcon
                    v-if='!user.avatar'
                    class='b-worker__avatar__icon'
                    icon='no-avatar'
                    size='10'
                    color='#fff'>
                </FwIcon>
            </div>

            <div class='b-user-list__item__text'>
                {{ user.name }}
            </div>
        </div>
    </div>
</div>
</template>

<script lang='ts'>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { userTableDataType } from '../../types/User';

@Component
export default class UserList extends Vue {
    @Prop({ type: Array, required: true }) readonly users!: Array<userTableDataType>;
    @Prop({ type: Number, default: null }) readonly userFilterId!: number;

    localList = [
        {
            'avatar': null,
            'name': 'All',
            'id': 0,
            'color': '#27DBBD',
        },
        ...this.users,
    ];
}
</script>

<style lang='sass'>
.b-user-list
    margin-left: 95px

    &__inner
        margin: 0 -10px
        display: flex
        cursor: pointer

    &__item__text
        width: 100%
        font-size: 10px
        text-align: center
        color: $dark-blue
        font-weight: 500
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis

    &__item__avatar
        width: 20px
        height: 20px
        border-radius: 10px
        margin-bottom: 6px
        opacity: 0.7
        display: flex
        align-items: center
        justify-content: center

    &__item
        width: 60px
        height: 60px
        border: 1px solid rgba(33,63,107,0.1)
        background-color: #fff
        border-radius: 10px
        display: flex
        flex-direction: column
        align-items: center
        justify-content: center
        margin: 0 5px
        padding: 5px
        transition: background-color 0.3s

        &--active
            background-color: lighten($main-green, 40)

            .b-user-list__item__text
                color: $main-green

        &:hover
            border-color: transparent
            background-color: lighten($main-green, 45)
</style>
